export default __webpack_public_path__ + "static/hero-animation-03-f58826c04870eb5281d9eb7cc160fecf.svg";